import { Location } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { CompanyService, GroupService, NgxToastrService, UserService, UtilsService } from "@core/services";
import { Company } from "@models";
import { NgbActiveModal, NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ValidatePrice } from "app/validators/price.validator";
import { Subscription } from "rxjs";
import { GoogleAutocompleteComponent } from "../../search/search-homepage/google-autocomplete/google-autocomplete.component";

@Component({
  selector: "app-group-form",
  templateUrl: "./group-form.component.html",
  styleUrls: ["./group-form.component.scss"],
})
export class GroupFormComponent implements OnInit, OnDestroy {
  company?: Company;
  @Input() travelPolicy: any;
  @Input() loading: Boolean;
  @Output() sendInfo = new EventEmitter<any>();
  subcriptions: Subscription[] = [];
  isAdmin: boolean;
  starRating = 0;
  isCreatePolicy: boolean = this.router.url.includes("create-group");
  toppings = new UntypedFormControl();
  @ViewChild("instanceCompany") instanceCompany: NgbTypeahead;
  dropdownSettings = {};
  form: UntypedFormGroup;
  isInvalid: boolean = false;
  showLocationModal = false;
  newPlace: string = '';
  newPlacePrice: number = null;
  modalPosition = { top: '0', left: '0' };
  isModalVisible = false;
  private buttonRef: ElementRef;
  locationError: string = '';
  @ViewChild('locationButton') set locationButton(button: ElementRef) {
    this.buttonRef = button;
  }
  assignmentScope: 'none' | 'all' | 'departments' | 'users' = 'none';
  selectedDepartments: string[] = [];
  selectedUsers: string[] = [];
  companyUsers: { 
    name: string; 
    lastname: string; 
    uuid: string; 
  }[] = [];
  departments: { uuid: string; name: string }[] = [];
  searchUserText = '';

  // PENDIENTE FILTRO DE VUELO POR UBICACIÓN / AEROUPERTO
  // @ViewChild('airportButton') set airportButton(button: ElementRef) {
  //   this.buttonRefAirport = button;
  // }
  // buttonRefAirport: ElementRef;
  // showAirportModal = false;
  // isAirportModalVisible = false;
  // newAirport: string = '';
  // newAirportPrice: number = null;
  // airportError: string = '';

  // @ViewChild('googleAirportAutocomplete') googleAirportAutocompleteComponent: GoogleAutocompleteComponent;
  @ViewChild('googleHotelAutocomplete') googleHotelAutocompleteComponent: GoogleAutocompleteComponent;
  lodgingTypeOptions = [
    { value: "room", text: "hotel.custom.request.option" },
    { value: "apartment", text: "hotel.apartment" },
    { value: "all", text: "expenses.all" },
  ];
  trainBudgetOptions = [
    { value: 10, label: '10%' },
    { value: 20, label: '20%' },
    { value: 30, label: '30%' },
    { value: 40, label: '40%' },
    { value: 50, label: '50%' },
    { value: 60, label: '60%' },
    { value: 70, label: '70%' },
    { value: 80, label: '80%' },
    { value: 90, label: '90%' },
    { value: 100, label: '100%' },
  ];
  sits = [
    {
      value: "ECONOMY",
      viewValue: "Economy",
    },
    {
      value: "PREMIUM_ECONOMY",
      viewValue: "Premium Economy",
    },
    {
      value: "BUSINESS",
      viewValue: "Business",
    },
    {
      value: "FIRST",
      viewValue: "First",
    },
  ];

  hotelPermits = [
    {
      value: "onlyAuthorization",
      text: "common.onlyAuthorization",
    },
    {
      value: "breakfast",
      text: "common.breakfast",
    },
    {
      value: "price",
      text: "group.group-form.show-price",
    },
    {
      value: "requestBooked",
      text: "group.group-form.book-allowed",
    },
  ];

  flightPermits = [
    {
      value: "onlyFlightAuthorization",
      text: "common.onlyFlightAuthorization",
    },
    {
      value: "flight",
      text: "group.group-form.flight-allowed",
    },
    {
      value: "requestCustomFlight",
      text: "group.group-form.customFlight-allowed",
    },
  ];

  trainPermits = [
    {
      value: "onlyTrainAuthorization",
      text: "common.onlyTrainAuthorization",
    },
    {
      value: "train",
      text: "group.group-form.train-allowed",
    },
    {
      value: "requestCustomTrain",
      text: "group.group-form.customTrain-allowed",
    },
  ];

  carPermits = [
    {
      value: true,
      text: "departament.departament-form.true",
    },
    {
      value: false,
      text: "departament.departament-form.false",
    },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    private location: Location,
    private utilsService: UtilsService,
    private companyService: CompanyService,
    private groupService: GroupService,
    private userService: UserService
  ) {
    const navigation = this.router.getCurrentNavigation();

    if (navigation && navigation.extras.state != null) {
      this.company = this.router.getCurrentNavigation().extras.state.company;
      this.travelPolicy = this.router.getCurrentNavigation().extras.state.travelPolicy;
      this.storeParams();
    } else {
      this.getFromLocalStorage();
    }
  }

  storeParams() {
    this.utilsService.storeParamInLocalStorage({
      title: "company",
      value: this.company,
    });
    this.utilsService.storeParamInLocalStorage({
      title: "travelPolicy",
      value: this.travelPolicy,
    });
  }

  getFromLocalStorage() {
    this.company = this.utilsService.getLocalStorageItem("company").value;
    this.travelPolicy = this.utilsService.getLocalStorageItem("travelPolicy").value;
  }

  ngOnDestroy(): void {
    this.utilsService.removeItemFromLocalStorage("company");
    this.utilsService.removeItemFromLocalStorage("travelPolicy");
    this.utilsService.removeItemFromLocalStorage("user");
  }

  ngOnInit() {
    if (this.travelPolicy && !this.travelPolicy.filters.onlyAuthorization) {
      this.travelPolicy.filters.onlyAuthorization = false;
    }
    this.form = this.formBuilder.group(
      {
        name: [
          this.travelPolicy ? this.travelPolicy.name : "",
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(30),
          ],
        ],
        stars: [
          this.travelPolicy ? this.travelPolicy.filters.stars : 1,
          [Validators.required, Validators.min(0), Validators.max(5)],
        ],
        priceMin: [
          this.travelPolicy ? this.travelPolicy.filters.priceMin.toFixed(2) : Number(0).toFixed(2),
          [Validators.required, Validators.min(0)],
        ],
        priceMax: [
          this.travelPolicy ? this.travelPolicy.filters.priceMax.toFixed(2) : Number(10).toFixed(2),
          [Validators.required, Validators.min(1)],
        ],
        priceMinFlight: [
          this.travelPolicy ? this.travelPolicy.filters.priceMinFlight?.toFixed(2) : Number(0).toFixed(2),
          [Validators.required, Validators.min(0)],
        ],
        priceMaxFlight: [
          this.travelPolicy ? this.travelPolicy.filters.priceMaxFlight?.toFixed(2) : Number(10).toFixed(2),
          [Validators.required, Validators.min(1)],
        ],
        priceMinTrain: [
          this.travelPolicy ? this.travelPolicy.filters.priceMinTrain?.toFixed(2) : Number(0).toFixed(2),
          [Validators.required, Validators.min(0)],
        ],
        priceMaxTrain: [
          this.travelPolicy ? this.travelPolicy.filters.priceMaxTrain?.toFixed(2) : Number(10).toFixed(2),
          [Validators.required, Validators.min(1)],
        ],
        onlyAuthorization: [
          this.travelPolicy ? this.travelPolicy.filters.onlyAuthorization : false,
        ],
        onlyFlightAuthorization: [
          this.travelPolicy ? this.travelPolicy.filters.onlyFlightAuthorization : false,
        ],
        onlyTrainAuthorization: [
          this.travelPolicy ? this.travelPolicy.filters.onlyTrainAuthorization : false,
        ],
        requestCustomFlight: [
          this.travelPolicy ? this.travelPolicy.filters.requestCustomFlight : false,
        ],
        requestCustomTrain: [
          this.travelPolicy ? this.travelPolicy.filters.requestCustomTrain : false,
        ],
        lodgingType: [
          this.travelPolicy ? this.travelPolicy.filters.lodgingType : "apartment",
          [Validators.required],
        ],
        // política de clase comentada hasta cambio de proveedor
        // sitType: [
        //   this.group && this.group.filters.sitType
        //     ? this.group.filters.sitType
        //     : "ECONOMY",
        // ],
        breakfast: [
          this.travelPolicy ? this.travelPolicy.filters.breakfast : false,
          [Validators.required],
        ],
        flight: [
          this.travelPolicy ? this.travelPolicy.filters.requestFlight : false,
          [Validators.required],
        ],
        train: [
          this.travelPolicy ? this.travelPolicy.filters.requestTrain : false,
          [Validators.required],
        ],
        requestBooked: [
          this.travelPolicy ? this.travelPolicy.filters.requestBooked : false,
          [Validators.required],
        ],
        requestCar: [
          this.travelPolicy && this.travelPolicy.filters.requestCar
            ? this.travelPolicy.filters.requestCar
            : false,
          [Validators.required],
        ],
        requestCustomBooking: [
          this.travelPolicy ? this.travelPolicy.filters.requestCustomBooking : false,
        ],
        requestCustomAirbnb: [
          this.travelPolicy ? this.travelPolicy.filters.requestCustomAirbnb : false,
        ],
        pricesByLocation: [
          this.travelPolicy?.filters?.pricesByLocation || [],
          [],
        ],
        // PENDIENTE FILTRO DE VUELO POR UBICACIÓN / AEROUPERTO
        // pricesByAirport: [
        //   this.travelPolicy?.filters?.pricesByAirport || [],
        //   []
        // ],
        allowAmountOverDuration: this.formBuilder.group({
          amount: [
            this.travelPolicy?.filters?.allowAmountOverDuration?.amount || null,
            [Validators.min(1)],
          ],
          duration: [
            this.travelPolicy?.filters?.allowAmountOverDuration?.duration || null,
            [Validators.min(1)],
          ],
        }),
        hotelDaysInAdvance: [
          this.travelPolicy && this.travelPolicy.filters.hotelDaysInAdvance
            ? this.travelPolicy.filters.hotelDaysInAdvance
            : 0,
          [Validators.min(0)],
        ],
        flightDaysInAdvance: [
          this.travelPolicy && this.travelPolicy.filters.flightDaysInAdvance
            ? this.travelPolicy.filters.flightDaysInAdvance
            : 0,
          [Validators.min(0)],
        ],
        trainDaysInAdvance: [
          this.travelPolicy && this.travelPolicy.filters.trainDaysInAdvance
            ? this.travelPolicy.filters.trainDaysInAdvance
            : 0,
          [Validators.min(0)],
        ],
      },
      { validator: ValidatePrice }
    );

    if (this.company && !this.travelPolicy) {
      this.form.addControl(
        "company",
        new UntypedFormControl(this.company ? this.company : "", [Validators.required])
      );
    }

    if (this.company?.uuid) {
      this.loadDepartments(this.company.uuid);
      this.loadCompanyUsers(this.company.uuid);
    }

    let policyUsersApplied = false;

    if (!this.isCreatePolicy && this.company?.uuid && this.travelPolicy?.uuid) {
      const companyUuid = this.company.uuid;
      const policyUuid  = this.travelPolicy.uuid;

      const sub = this.userService.getUsersByPolicy(companyUuid, policyUuid).subscribe({
        next: (policyUsers: any[]) => {
          const uuids = (policyUsers || []).map(u => u.uuid);
          if (uuids.length > 0) {
            this.selectedUsers = uuids;
            this.assignmentScope = 'users';
            policyUsersApplied = true;
          } else {
            this.assignmentScope = 'none';
          }
        },
        error: () => {
        }
      });
      this.subcriptions.push(sub);
    }

    if (this.travelPolicy && !policyUsersApplied) {
      const users = this.travelPolicy.users || [];
      const departments = this.travelPolicy.departments || this.travelPolicy.groups || [];
      const isAll = this.travelPolicy.assignToAll === true;

      if (isAll) {
        this.assignmentScope = 'all';
        this.selectedUsers = [];
        this.selectedDepartments = [];
      } else if (Array.isArray(users) && users.length > 0) {
        this.assignmentScope = 'users';
        this.selectedUsers = users.map((u: any) => typeof u === 'string' ? u : u.uuid);
      } else if (Array.isArray(departments) && departments.length > 0) {
        this.assignmentScope = 'departments';
        this.selectedDepartments = departments.map((d: any) => typeof d === 'string' ? d : d.uuid);
      } else {
        this.assignmentScope = 'none';
      }
    }
  }

  get f() {
    return this.form.controls;
  }

  onSubmit() {
    // let formData = new FormData();
    // let attributes = {};
    this.isInvalid = false;
    const allowAmountOverDuration = this.f.allowAmountOverDuration.value;

    const objectToEmit: any = {
      company: !this.travelPolicy ? this.f.company.value : undefined,
      name: this.f.name.value,
      filters: {
        stars: this.f.stars.value,
        priceMin: this.f.priceMin.value,
        priceMax: this.f.priceMax.value,
        priceMinFlight: this.f.priceMinFlight.value,
        priceMaxFlight: this.f.priceMaxFlight.value,
        priceMinTrain: this.f.priceMinTrain.value,
        priceMaxTrain: this.f.priceMaxTrain.value,
        lodgingType: this.f.lodgingType.value,
        breakfast: this.f.breakfast.value,
        requestFlight: this.f.flight.value,
        requestTrain: this.f.train.value,
        requestBooked: this.f.requestBooked.value,
        onlyAuthorization: this.f.onlyAuthorization.value,
        onlyFlightAuthorization:
          this.f.onlyFlightAuthorization.value !== null
            ? this.f.onlyFlightAuthorization.value
            : false,
        onlyTrainAuthorization:
          this.f.onlyTrainAuthorization.value !== null
            ? this.f.onlyTrainAuthorization.value
            : false,
        requestCustomBooking:
          this.f.requestCustomBooking.value !== null
            ? this.f.requestCustomBooking.value
            : true,
        requestCustomAirbnb:
          this.f.requestCustomAirbnb.value !== null
            ? this.f.requestCustomAirbnb.value
            : true,
        pricesByLocation: this.f.pricesByLocation.value || [],
        // PENDIENTE FILTRO DE VUELO POR UBICACIÓN / AEROUPERTO
        // pricesByAirport: this.f.pricesByAirport.value || [],
        requestCustomTrain:
          this.f.requestCustomTrain.value !== null
            ? this.f.requestCustomTrain.value
            : false,
        requestCustomFlight:
          this.f.requestCustomFlight.value !== null
            ? this.f.requestCustomFlight.value
            : true,
        requestCar: this.f.requestCar.value,
        // política de clase comentada hasta cambio de proveedor
        // sitType: this.f.sitType.value,
        hotelDaysInAdvance: this.f.hotelDaysInAdvance.value,
        flightDaysInAdvance: this.f.flightDaysInAdvance.value,
        trainDaysInAdvance: this.f.trainDaysInAdvance.value,
      },
    };

    if (
      allowAmountOverDuration &&
      allowAmountOverDuration.amount !== null &&
      allowAmountOverDuration.duration !== null
    ) {
      objectToEmit.filters.allowAmountOverDuration = allowAmountOverDuration;
    }

    const assignToAll = this.assignmentScope === 'all';
    const users: string[] =
      this.assignmentScope === 'users' ? [...this.selectedUsers] : [];
    const departments: string[] =
      this.assignmentScope === 'departments' ? [...this.selectedDepartments] : [];

    const sanitize = (arr: string[]) => arr.filter(Boolean);

    const body = {
      name: objectToEmit.name,
      filters: objectToEmit.filters,
      users: sanitize(users),
      departments: sanitize(departments),
      assignToAll,
    };

    const bodyEdit = {
      uuid: this.travelPolicy ? this.travelPolicy.uuid : undefined,
      name: objectToEmit.name,
      filters: objectToEmit.filters,
      users: sanitize(users),
      departments: sanitize(departments),
      assignToAll,
    };

    const action = this.isCreatePolicy
      ? this.companyService.createCompanyPolicies(this.company?.uuid, body)
      : this.companyService.putCompanyPolicies(this.company?.uuid, bodyEdit);
    this.subcriptions.push(
      action.subscribe(
        (res) => {
          this.loading = false;
          this.translate
            .get(
              !this.isCreatePolicy
                ? "group.group-form.success-edit-policies"
                : "group.group-form.success-create-policies"
            )
            .subscribe((result) => {
              this.ngxToastrService.typeSuccess(null, result);
              this.goBack();
            });
          this.travelPolicy = res;
        },
        (err) => {
          this.loading = false;
          this.translate
            .get(
              this.isCreatePolicy
                ? "group.group-form.error-create-policies"
                : "group.group-form.error-edit-policies"
            )
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.message);
            });
        }
      )
    );
    // this.sendInfo.emit(objectToEmit);
  }

  // setValue(event, id: string) {
  //   if (id == 'hotelPermits') {
  //     this.hotelPermits.forEach(h => {
  //       const val = h.value;
  //       this.form.get(val).setValue(false);
  //     });
  //   } else if (id == "fligthPermits") {
  //     this.flightPermits.forEach((h) => {
  //       const val = h.value;
  //       this.form.get(val).setValue(false);
  //     });
  //   } else if (id == "trainPermits") {
  //     this.trainPermits.forEach((h) => {
  //       const val = h.value;
  //       this.form.get(val).setValue(false);
  //     });
  //   }

  //   if (event.length > 0) {
  //     event.forEach((s) => {
  //       if (this.form.get(s)) {
  //         const value = this.form.get(s).value;
  //         this.form.get(s).setValue(true);
  //       }
  //     });
  //   }
  // }

  openLocationModal() {
    this.newPlace = '';
    this.newPlacePrice = null;
    this.locationError = '';
    
    if (this.buttonRef) {
      const button = this.buttonRef.nativeElement;
      const rect = button.getBoundingClientRect();
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollX = window.scrollX || document.documentElement.scrollLeft;
      
      let top = rect.top + scrollY -100;
      let left = rect.left + scrollX - 510;
      
      if (left < 10) {
        left = 10;
      }
      
      const modalHeightEstimate = 300;
      if (top + modalHeightEstimate > window.innerHeight + scrollY) {
        top = window.innerHeight + scrollY - modalHeightEstimate - 100;
      }
      
      this.modalPosition = {
        top: `${top}px`,
        left: `${left}px`,
      };
    }
    
    this.showLocationModal = true;
    setTimeout(() => {
      this.isModalVisible = true;
    }, 10);
    this.showLocationModal = true;
  }

  closeLocationModal() {
    this.isModalVisible = false;
    setTimeout(() => {
      this.showLocationModal = false;
      document.body.style.overflow = '';
    }, 200);
  }

  handleSetAddress(place: any) {
    this.locationError = '';

    const components = place.address_components;
    if (!components || components.length === 0) {
      this.newPlace = '';
      return;
    }

    const getComponent = (type: string): string => {
      const comp = components.find(c => c.types.includes(type));
      return comp?.long_name || '';
    };

    const region = getComponent('administrative_area_level_2') || getComponent('administrative_area_level_1');
    const country = getComponent('country');

    if (!region && !country) {
      this.locationError = this.translate.instant('group.group-form.invalid-location');
      return;
    }
    this.newPlace = [region, country].filter(Boolean).join(', ');
  }

  addLocationPrice() {
    this.locationError = '';

    if (!this.newPlace || !this.newPlacePrice) {
      return;
    }

    if (this.newPlacePrice <= 0) {
      this.locationError = this.translate.instant('group.group-form.invalid-price');
      return;
    }

    const currentLocations = this.form.get('pricesByLocation').value || [];
    
    const alreadyExists = currentLocations.some(loc => 
      loc.placeName.toLowerCase() === this.newPlace.toLowerCase()
    );

    if (alreadyExists) {
      this.locationError = this.translate.instant('group.group-form.add-location-error');
      return;
    }

    this.form.get('pricesByLocation').setValue([
      ...currentLocations,
      { placeName: this.newPlace, priceMax: this.newPlacePrice }
    ]);

    this.newPlace = '';
    this.newPlacePrice = null;
    
    if (this.googleHotelAutocompleteComponent) {
      this.googleHotelAutocompleteComponent.reset();
    }
  }

  removeLocationPrice(loc) {
    const updated = this.form.get('pricesByLocation').value.filter(
      (item) => item.placeName !== loc.placeName
    );
    this.form.get('pricesByLocation').setValue(updated);
  }

  // PENDIENTE FILTRO DE VUELO POR UBICACIÓN / AEROUPERTO
  // openAirportModal() {
  //   this.newAirport = '';
  //   this.newAirportPrice = null;
  //   this.airportError = '';

  //   if (this.buttonRefAirport) {
  //     const button = this.buttonRefAirport.nativeElement;
  //     const rect = button.getBoundingClientRect();
  //     const scrollY = window.scrollY || document.documentElement.scrollTop;
  //     const scrollX = window.scrollX || document.documentElement.scrollLeft;

  //     let top = rect.top + scrollY - 100;
  //     let left = rect.left + scrollX - 510;

  //     if (left < 10) {
  //       left = 10;
  //     }

  //     const modalHeightEstimate = 300;
  //     if (top + modalHeightEstimate > window.innerHeight + scrollY) {
  //       top = window.innerHeight + scrollY - modalHeightEstimate - 100;
  //     }

  //     this.modalPosition = {
  //       top: `${top}px`,
  //       left: `${left}px`,
  //     };
  //   }

  //   this.showAirportModal = true;
  //   setTimeout(() => {
  //     this.isAirportModalVisible = true;
  //   }, 10);
  // }

  // closeAirportModal() {
  //   this.isAirportModalVisible = false;
  //   setTimeout(() => {
  //     this.showAirportModal = false;
  //     document.body.style.overflow = '';
  //   }, 200);
  // }


  // handleSetAirport(place: any) {
  //   this.airportError = '';

  //   if (!place.name || !place.place_id || !place.types?.includes('airport')) {
  //     this.airportError = this.translate.instant('group.group-form.invalid-airport');
  //     return;
  //   }

  //   this.newAirport = place.name;
  // }

  // addAirportPrice() {
  //   this.airportError = '';

  //   if (!this.newAirport || !this.newAirportPrice) {
  //     return;
  //   }

  //   if (this.newAirportPrice <= 0) {
  //     this.airportError = this.translate.instant('group.group-form.invalid-price');
  //     return;
  //   }

  //   const currentAirports = this.form.get('pricesByAirport').value || [];

  //   const alreadyExists = currentAirports.some(
  //     airport => airport.placeName.toLowerCase() === this.newAirport.toLowerCase()
  //   );

  //   if (alreadyExists) {
  //     this.airportError = this.translate.instant('group.group-form.add-route-error');
  //     return;
  //   }

  //   this.form.get('pricesByAirport').setValue([
  //     ...currentAirports,
  //     { placeName: this.newAirport, priceMax: this.newAirportPrice }
  //   ]);

  //   this.newAirport = '';
  //   this.newAirportPrice = null;

  //   if (this.googleAirportAutocompleteComponent) {
  //     this.googleAirportAutocompleteComponent.reset();
  //   }
  // }

  // removeAirportPrice(airport) {
  //   const updated = this.form.get('pricesByAirport').value.filter(
  //     item => item.placeName !== airport.placeName
  //   );
  //   this.form.get('pricesByAirport').setValue(updated);
  // }

  handleInvalidAddress() {
    this.locationError = this.translate.instant('group.group-form.invalid-location');
    this.newPlace = '';
    this.newPlacePrice = null;
  }

  private loadDepartments(companyUuid: string) {
    this.subcriptions.push(
      this.groupService.getGroups(companyUuid).subscribe({
        next: (groups: any[]) => {
          const list = (groups || []).map(g => ({ uuid: g.uuid, name: g.name }));
          const withoutDefault = list.filter(g => g.name !== 'Default');
          const defaultItem = list.find(g => g.name === 'Default');
          this.departments = defaultItem ? [...withoutDefault, defaultItem] : list;
        },
        error: (err) => {
          this.translate.get("company.company-detail.error-get-groups")
            .subscribe(msg => this.ngxToastrService.typeInfo(msg, err?.message || ''));
        }
      })
    );
  }

  private loadCompanyUsers(companyUuid: string) {
    this.subcriptions.push(
      this.companyService.getCompanyUsers(companyUuid).subscribe({
        next: (res: any[]) => {
          this.companyUsers = (res || []).map(u => ({
            name: u.name, lastname: u.lastname, uuid: u.uuid
          }));
        },
        error: () => {}
      })
    );
  }

  isAssignmentInvalid(): boolean {
    if (this.assignmentScope === 'departments') return this.selectedDepartments.length === 0;
    if (this.assignmentScope === 'users') return this.selectedUsers.length === 0;
    return false;
  }

  goBack() {
    this.location.back();
  }

  resetUsersFilter() {
    this.searchUserText = '';
  }

  filterCompanyUsers(value: string) {
    this.searchUserText = (value || '').trim().toLowerCase();
  }

  userMatchesSearch(user: { name: string; lastname: string }): boolean {
    const q = (this.searchUserText || '').trim().toLowerCase();
    if (!q) return true;
    return (`${user.name} ${user.lastname}`.toLowerCase().includes(q));
  }

}
